export const ParseErrorCodes = {
  INVALID_SESSION_TOKEN: 209,
  INVALID_AUTH: 119
} as const

export const isAuthError = (code: number) => {
  return [ParseErrorCodes.INVALID_SESSION_TOKEN, ParseErrorCodes.INVALID_AUTH].includes(code as any)
}
